<div class="modal-header" [ngClass]="{ 'product-header': type === 'product' }">
  <h5 class="modal-title">
    <ng-container *ngIf="type === 'product'">
      Product Image — {{ productCode }} ({{ index + 1 }}/{{ images.length }})
    </ng-container>

    <ng-container *ngIf="type === 'signature'">
      Signature — {{ signer || 'Unknown' }}
    </ng-container>

    <ng-container *ngIf="type === 'document'">
      {{ fileName || 'Document' }}
    </ng-container>
  </h5>

  <div class="modal-actions">
    <a *ngIf="isPdf" class="download-button" [href]="fileURL" [download]="fileName || 'document.pdf'">
      <i class="fas fa-download"></i>
      Download
    </a>
    <button type="button" class="close-button" (click)="closeDialog()" aria-label="Close preview">✕</button>
  </div>
</div>

<div *ngIf="isPdf; else imageViewer" class="modal-body pdf-body">
  <iframe [src]="safeFileURL" [title]="fileName || 'PDF document'"></iframe>
</div>

<ng-template #imageViewer>
  <div class="modal-body image-body">

    <!-- LEFT -->
    <button
      *ngIf="images.length > 1 && index > 0"
      class="nav-arrow left"
      (click)="prev()"
    >
      <i class="fas fa-chevron-left"></i>
    </button>

    <!-- IMAGE -->
    <img [src]="fileURL" class="modal-image" />

    <!-- RIGHT -->
    <button
      *ngIf="images.length > 1 && index < images.length - 1"
      class="nav-arrow right"
      (click)="next()"
    >
      <i class="fas fa-chevron-right"></i>
    </button>
  </div>

  <div class="thumbnail-strip" *ngIf="type === 'product' && images.length > 1">
    <div
      class="thumb-wrapper"
      *ngFor="let thumb of thumbnails; let i = index"
      [ngClass]="{ active: i === index }"
      (click)="goTo(i)"
    >
      <img [src]="thumb" class="thumbnail" />
    </div>
  </div>
</ng-template>
